import { render, staticRenderFns } from "./Details_Master.vue?vue&type=template&id=76ed4d8d&"
import script from "./Details_Master.vue?vue&type=script&lang=js&"
export * from "./Details_Master.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports